import React, {useEffect} from "react";
import {Avatar, ListItem, ListItemAvatar, ListItemText} from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faComment} from "@fortawesome/pro-solid-svg-icons";

dayjs.extend(relativeTime);

export default function ToastComponent({title = "", message = "", onNotificationClick}) {
	// const router = useRouter();

	// depricated
	// const onClick = () => {
	// 	console.log("ClickData: ", data);
	// 	const {id, type, pageId} = data;
	// 	if (id !== undefined && type !== undefined && pageId !== undefined) {
	// 		const path = (type.toLowerCase() === "message")  ? "/message/" : "/activity/";
	// 		router.push(path + pageId);
	// 	}
	// };

	//console.log("ToastComponent : title ", title);
	// useEffect(() => {
	// 	console.log("ToastComponent", data);
	// }, [data]);

	useEffect(() => {
		if (title.includes("💬")) title = title.substring(2);
	}, []);


	return (
		<ListItem
			onClick={() => onNotificationClick()} alignItems="flex-start" sx={{minWidth: "280px", padding: 0, cursor: "pointer"}}>
			<ListItemAvatar sx={{minWidth: 38}}>
				<Avatar sx={{bgcolor: "#f6c35d"}}>
					<FontAwesomeIcon icon={faComment} size={"xl"}/>
				</Avatar>
			</ListItemAvatar>
			<ListItemText primary={title?.trim().startsWith("💬") ? title.slice("💬".length) : title} secondary={message} sx={{paddingLeft: "16px", width: "250px"}}
						  slotProps={{
							  primary: {
								  variant: "subtitle2",
								  style: {
									  fontSize: "14px",
									  whiteSpace: "nowrap",
									  overflow: "hidden",
									  textOverflow: "ellipsis"
								  }
							  },
							  secondary: {
								  variant: "caption"
							  }
						  }}
			/>
		</ListItem>
	);
}
